import React, { useEffect, useState, useCallback } from 'react';
import './ClinicChatView.css';
import FormatUrl from '../../utils/UrlFormatter';

const PatientSidebar = ({ clinicId, selectedPatientId, onSelectPatient, onCollapseSidebar }) => {
  const [patients, setPatients] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchPatients = useCallback(async () => {
    if (!clinicId) return;

    try {
      const csrfUrl = FormatUrl(`/csrf-token/`);
      const csrfResponse = await fetch(csrfUrl, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });

      if (!csrfResponse.ok) throw new Error('Failed to fetch CSRF token');
      const csrfData = await csrfResponse.json();

      const url = FormatUrl(`/conv/patient_conv_stats?clinic_id=${clinicId}`);
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfData.csrfToken,
        },
        credentials: 'include',
      });

      if (!response.ok) throw new Error('Failed to fetch conversation status');
      const data = await response.json();

      setPatients(data || []);
    } catch (error) {
      console.error('Error fetching patient conversation status:', error);
    }
  }, [clinicId]);

  useEffect(() => {
    fetchPatients();
  }, [fetchPatients]);

  const filteredPatients = patients.filter((p) => {
    const fullName = `${p.first_name} ${p.last_name}`.toLowerCase();
    return fullName.includes(searchQuery.toLowerCase());
  });

  return (
    <div className="chat-sidebar">
      <div className="sidebar-header">
        <div className="sidebar-header-top">
          <h2>Patients</h2>
          {!isMobileView && onCollapseSidebar && (
            <button className="collapse-btn" onClick={onCollapseSidebar}>
              ❮
            </button>
          )}
        </div>
      </div>

      <div className="sidebar-search-container">
        <input
          type="text"
          className="patient-search"
          placeholder="Search patients..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="chat-patient-list">
        {filteredPatients.map((patient) => {
          const label = `${patient.first_name} ${patient.last_name}`;
          return (
            <div
              key={patient.patient_profile_id}
              className={`chat-participant ${
                selectedPatientId === patient.patient_profile_id ? 'active' : ''
              }`}
              onClick={() => onSelectPatient(patient)}
            >
              {label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PatientSidebar;
